import { render } from "./attest-travail-uigb.vue?vue&type=template&id=57f2ed8a"
import script from "./attest-travail-uigb.vue?vue&type=script&lang=js"
export * from "./attest-travail-uigb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__